var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Results - Your Indoor Cycling Solution"
    }
  }), _c('div', {
    staticClass: "iframe"
  }, [_c('iframe', {
    ref: "resultiframe",
    attrs: {
      "src": _vm.iframeUrl,
      "width": "100%",
      "scrolling": "auto",
      "frameborder": "0",
      "allowtransparency": true
    }
  })])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }